import { createApp } from "vue";
import App from "./app.vue";
import router from "./router";
import KeyCloakService from "./security/keycloak-service";
import VueApexCharts from "vue3-apexcharts";
import "./style.css";
import HttpService from "./services/http-service";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import VueMask from "@devindex/vue-mask";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

// Toast configuration
const toastOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  maxToasts: 3,
  toastClassName: "custom-toast",
};

// const nodeEnv = process.env.NODE_ENV;
const renderApp = () => {
  const app = createApp(App);

  app.use(router);
  app.use(VueMask);
  app.use(VueApexCharts);
  app.component("VueTailwindDatepicker", VueTailwindDatepicker);
  app.use(Toast, toastOptions);

  return app.mount("#app");
};

KeyCloakService.CallLogin(renderApp);
HttpService.configureAxiosKeycloak();
